import React from 'react';
import ReactDOM from 'react-dom';
import { logger } from 'packages';
import MopinionButton from './mopinion-button';
import { isEnabled } from './mopinion-loader';
import initData from 'init-data';

const renderMopinionButton = mopinionDeploymentId => {
    if (!isEnabled() || !mopinionDeploymentId) {
        return;
    }
    try {
        let element = document.getElementById('mopinion-widget-button');
        ReactDOM.render(
            <MopinionButton
                memberId={initData.memberId}
                mopinionDeploymentId={mopinionDeploymentId}
            />,
            element
        );
    } catch (e) {
        logger(e);
    }
};

/**
For use with Google Tag Manager:

<script type="text/javascript">
  (function() {
    var mopinionDeploymentId = 'wn05g86aghlgi91ctabv3m29illmqf7nfx4';
    var maxAttempts = 10;
    var t = setInterval(function() {
      if (window.renderMopinionButton) {
        window.renderMopinionButton(mopinionDeploymentId);
        clearInterval(t);
      }
      else if (--maxAttempts < 1) {
        clearInterval(t);
      }
    }, 500)
    })();
</script>
*/
window.renderMopinionButton = renderMopinionButton;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/customer-feedback/mopinion-button-renderer.js